import { useState } from "react";
import Login from "@/components/Login";
import Register from "@/components/Register";
import Header from "@/components/Header";

const AuthPage = () => {
  const [isLoginView, setIsLoginView] = useState(true);

  const toggleView = () => {
    setIsLoginView(!isLoginView);
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-grow flex items-center justify-center p-4">
        <div className="relative w-full max-w-md h-[34rem] overflow-hidden">
          <div
            className={`absolute top-0 left-0 w-full h-full transition-transform duration-700 ease-in-out ${
              isLoginView ? "transform translate-x-0" : "transform -translate-x-full"
            }`}
          >
            <Login onToggle={toggleView} />
          </div>
          <div
            className={`absolute top-0 left-0 w-full h-full transition-transform duration-700 ease-in-out ${
              isLoginView ? "transform translate-x-full" : "transform translate-x-0"
            }`}
          >
            <Register onToggle={toggleView} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default AuthPage;